import React, { useMemo } from "react";

import { AssigneeBanner } from "../../../components/AssigneeBanner";
import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";
import { User } from "../../../model/user/User";
import { permissionSliceSelectors } from "../../../redux/permission/permission.selector";
import { useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { Checkbox } from "../../../utils/local-antd";

type KanbanAutomationRecipientsPickerProps = {
  value: string[];
  onChange: (recipientUserIds: string[]) => void;
};

export const KanbanAutomationRecipientsPicker: React.FC<
  KanbanAutomationRecipientsPickerProps
> = ({ value, onChange }) => {
  const user = useAppSelector(userSliceSelectors.selectLoggedInUser);
  const members = useAppSelector(permissionSliceSelectors.selectMembers);

  const people = useMemo(() => {
    const owner = user?.organization ?? user;

    return [owner, ...members].filter(
      (person, index, all): person is User =>
        Boolean(person) &&
        all.findIndex((other) => other?._id === person?._id) === index,
    );
  }, [user, members]);

  const toggle = (personId: string, checked: boolean) =>
    onChange(
      checked
        ? [...value, personId]
        : value.filter((recipientId) => recipientId !== personId),
    );

  return (
    <Flex flexDirection="column" gap="s">
      {people.map((person) => (
        <Checkbox
          key={person._id}
          checked={value.includes(person._id)}
          onChange={(e) => toggle(person._id, e.target.checked)}
        >
          <Flex alignItems="center" gap="s">
            <AssigneeBanner hideSelf assignees={[person]} title={person.name} />
            <Text>{person.name}</Text>
          </Flex>
        </Checkbox>
      ))}
    </Flex>
  );
};
